function encodeTypeForCs(type: string): string {
    const collapsed = type.trim().replace(/\s+/g, ' ') // NOSONAR
    return encodeURIComponent(collapsed).replace(/%20/g, '+') // NOSONAR
}

export function buildPublisherUrl(
    baseUrl: string | undefined,
    contentId: string | undefined,
    documentTypes: string[] | undefined,
): string | undefined {
    const base = baseUrl?.trim()
    if (!base) return undefined

    const cid = contentId?.trim()
    if (!cid || cid === '-') return undefined

    if (!Array.isArray(documentTypes)) return undefined
    const types: string[] = []
    for (const t of documentTypes) {
        if (typeof t === 'string' && t.trim()) types.push(t)
    }
    if (!types.length) return undefined

    const parts = [
        `cid=${encodeURIComponent(cid)}`,
        ...types.map(t => `cs=${encodeTypeForCs(t)}`),
    ]
    return `${base}?${parts.join('&')}`
}
